import { genComponentInstance } from '@/utils/utils';
import Component from './index.vue';

/**
 * 设置设备地图坐标
 * @param {Object} data
 * @param {{ longitude: number, latitude: number }} data.coords
 * @param {HTMLElement} data.container default:document.body 组件容器
 */
export function openDevicePointMap(data) {
  const instance = genComponentInstance(Component, data);
  instance.$mount();
}
